module.exports = __webpack_public_path__ + "static/img/19078D_2_R_20230206_fit.238f662.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/19078D_2_R_20230206_fit.png
// module id = FHXB
// module chunks = 0